import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  FaUserMd,
  FaUserAlt,
  FaHospitalAlt,
  FaUsers,
  FaRunning,
  FaChild,
  FaHeartbeat,
  FaCapsules,
  FaStethoscope,
  FaClock,
} from "react-icons/fa";
import Doc1 from '../assets/images/Doc1.png';
import Doc2 from '../assets/images/Doc2.png';

const About = () => {
  return (
    <div className="mt-5 p-5" style={{ background: "aliceblue" }}>
      <h2 className="text-center mb-4 text-primary">              <FaUserMd className="text-primary] mb-2 me-2" size={30} />
      Directors</h2>
      <Row className="mb-5">
  <Col md={6}>
    <Card className="p-4 shadow h-100 d-flex flex-column align-items-center">
      <img
        src={Doc1}
        alt="User"
        className="mb-3"
        style={{
          width: '200px',
          height: '250px',
          borderRadius: 10,
          objectFit: 'contain',
        }}
      />
      <h4>DR. ARPIT GOYAL</h4>
      <p className="text-center">
        M.B.B.S from Gajra Raja Medical College Gwalior (Batch 2007-2012) <br />
        M.S. Anatomy from Gajra Raja Medical College Gwalior (Batch 2021-2025)
      </p>
    </Card>
  </Col>
  <Col md={6}>
    <Card className="p-4 shadow h-100 d-flex flex-column align-items-center">
      <img
        src={Doc2}
        alt="User"
        className="mb-3"
        style={{
          width: '200px',
          height: '250px',
          borderRadius: 10,
          objectFit: 'contain',
        }}
      />
      <h4>DR. ANJALI AGRAWAL</h4>
      <p className="text-center">
        B.H.M.S. from Government Homeopathic Medical College Bhopal (Batch 2011-2016)
      </p>
    </Card>
  </Col>
</Row>


      <h2 className="text-center text-primary mb-4">
        WHY WE NEED HOME MEDICAL SERVICE AT PRESENT SITUATION (KALYUG)
      </h2>
      <Row className="g-4 mb-5">
        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaUsers className="text-info mb-2" size={60} />
              <p className="ms-3">
                <strong>1. Change in Family Structure:</strong> Due to change in
                family structure from multigeneration to nuclear family, and
                even most of elderly couple (whose children live in another
                city), live in flats or in society alone or small family whose
                working hand are going for job or business and depend on
                neighbours and friends for any medical emergency and even
                sometime for small medical problem etc.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaHospitalAlt className="text-danger mb-2" size={40} />
              <p className="ms-3">
                <strong>2. Recovery at Home:</strong> In case of recovering
                phase from any medical or surgical illness for which hospital
                stay is not possible or affordable, in that case we provide our
                best related medical service at your home with best trained
                staff and doctors with minimum expenditure.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaStethoscope className="text-warning mb-2" size={50} />
              <p className="ms-3">
                <strong>3. Mismanagement of Common Illnesses:</strong> In case
                of small medical illness (fever, pain in abdomen, vomiting) we
                go to medical store and take medicine and not get relief and
                then go to doctor and spend so many money in investigation and
                after that we get correct treatment and suffer very much—patient
                and their family member.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaHeartbeat className="text-primary mb-2" size={100} />
              <p className="ms-3">
                <strong>4. Rise in Chronic Illnesses:</strong> At present, at
                least one member of each family is suffering from illness
                (diabetes, hypertension, allergy, indigestion). Almost all we
                take treatment from some doctor and some get relief and some
                not, and spend life with suffer. And sometimes, even after
                taking medicine, our disease is not controlled and in future it
                converts into major illness: Uncontrolled diabetes → decreased
                vision (diabetic retinopathy secondary to cataract), kidney
                failure (diabetic nephropathy) Uncontrolled B.P and lipid
                profile → heart attack Allergy (sneezing) → irritable lifestyle
                (especially in changing weather) Indigestion/constipation →
                acidity/piles (babasir) due to present lifestyle/working style
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaClock className="text-success mb-2" size={150} />
              <p className="ms-3">
                <strong>5. Lack of Time:</strong> In pregnancy, previously
                pregnancy goes very smoothly because person living with
                experienced mother and grandmother and follow their instruction
                very strictly. Nowadays, many newly pregnant mothers are living
                alone or develop very problems that are not managed by old
                ideas. Pregnancy time (very memorable and crucial time) for baby
                and mother—for that, they require special medical advice and
                care from the 1st day of knowing about this beautiful moment of
                life up to a successful and healthy baby and mother. You have to
                know what we do or what we not to do to prevent unnecessary
                complications (stillbirth, baby with abnormalities that
                diagnosed at birth or after birth, or mother sometimes gets
                hospitalised during pregnancy) that many pregnant females
                experience due to lack of proper medical guidance. We always
                confuse— which doctor we consult… experienced or new? which
                doctor does normal delivery or many doctors do only operation?
                what we monitor during pregnancy (sugar, B.P., diet schedule,
                necessary investigation, doctor consultation during 1st, 2nd,
                3rd trimester)... Female doctor and staff always remain in touch
                with you and your baby.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaChild className="text-secondary mb-2" size={35} />
              <p className="ms-3">
                <strong>6. Newborn Care:</strong> Vaccination
                schedule at home Healthy diet schedule from 6 months onward to
                5th year age (to prevent most common problems in children:
                spectacle / not gaining weight / height)
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaRunning className="text-pink mb-2" size={50} />
              <p className="ms-3">
                <strong>7. Physiotherapy at Home:</strong> Just like medication
                is essential for treating diseases, physiotherapy is equally
                necessary for rapid and better recovery of patients. It also
                helps improve the emotional and mental status of the patient. In
                contrast to self-administered home-made physiotherapy,
                professional physiotherapy at home ensures proper treatment,
                preventing increased problems and disabilities.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaUserAlt className="text-dark mb-2" size={100} />
              <p className="ms-3">
                <strong>8. Elderly Care:</strong> As in our whole
                life, there are three phases: From birth to before marriage
                (parents take care of you). From marriage to adult children (a
                person takes care of themselves). After the age of 45-50 years,
                a person needs their children to take care of them, and they
                care very well. After 45-50 years, our body becomes susceptible
                to many diseases (e.g., diabetes, hypertension, joint pain,
                difficulty in walking, cataracts, decreased vision). In addition
                to children’s care, medical care is also needed, just like
                within the family. Our aim is to create a barrier in the body to
                prevent these diseases, and if required, provide treatment for
                them.
              </p>
            </div>
          </Card>
        </Col>
      </Row>

      <h2 className="text-center text-primary mb-4">
        Benefits of Home Medical Services at Home
      </h2>
      <Row className="g-4">
        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaCapsules className="text-danger mb-2" size={30} />
              <p className="ms-3">
                <strong>1. Personalized Family-Like Care:</strong> A family doctor treats patients like a family member, always providing the best and most accurate medical advice, while remaining compassionate and comprehensive toward the patient.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaCapsules className="text-success mb-2" size={50} />
              <p className="ms-3">
                <strong>2. Safe Recovery at Home:</strong> In Case of Acute Medical Illness, Instead of going to a medical store and taking general medicine, communicate with a doctor to get the proper medication and recover safely at home. A medical store person may not know which medicine is unsuitable for you or your family members, which could sometimes lead to very serious medical issues.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaCapsules className="text-primary mb-2" size={30} />
              <p className="ms-3">
                <strong>3. Avoid Unnecessary Hospitalization:</strong> Not All Medical Illnesses Require Hospitalization but due to lack of knowledge and proper medical treatment at home, people often end up getting hospitalized, spending a lot of money, and suffering unnecessarily.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaCapsules className="text-warning mb-2" size={25} />
              <p className="ms-3">
                <strong>4. No Waiting Time:</strong> Avoid unnecessary waiting
                outside doctor clinics. Receive care instantly in the comfort of
                your home.
              </p>
            </div>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="p-4 shadow-sm h-100">
            <div className="d-flex align-items-center">
              <FaCapsules className="text-info mb-2" size={40} />
              <p className="ms-3">
                <strong>5. Proper Guidance & Referral:</strong> In Case of Major/Undiagnosed Illness, our doctor helps in making the primary diagnosis and suggests which specialist you should consult. We also communicate with the best hospitals in the city (based on medical needs and financial considerations) to provide immediate and quality service to our patients.
              </p>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default About;
